import { render, staticRenderFns } from "./business-report.vue?vue&type=template&id=b0c674aa&scoped=true&"
import script from "./business-report.vue?vue&type=script&lang=js&"
export * from "./business-report.vue?vue&type=script&lang=js&"
import style0 from "./business-report.vue?vue&type=style&index=0&id=b0c674aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c674aa",
  null
  
)

export default component.exports